import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';

import { MemberTypeStrings } from 'common/src/app/data/enum/MemberType';
import Pages from 'common/src/app/data/enum/Pages';

import LocaleMessage from '../../../../atoms/LocaleMessage';
import TextNew from '../../../../atoms/TextNew';

const MedicalCheckAgeError = ({ isSixteenToSeventeen, registrationType, publicHost }) => (
  <>
    <TextNew.PrimaryElegant
      localeId={`medicalCheck.blockingErrors.ageNotAllowed.${registrationType}.main`}
    />

    {isSixteenToSeventeen && registrationType === MemberTypeStrings.ONLINE && (
      <TextNew.PrimaryOriginal>
        <Link to={`${publicHost}${Pages.UK_PUBLIC_WHAT_HAPPENS_IN_GROUP}`} target="_blank">
          <LocaleMessage id="medicalCheck.blockingErrors.ageNotAllowed.online.findOutMoreCTA" />
        </Link>
      </TextNew.PrimaryOriginal>
    )}
  </>
);

MedicalCheckAgeError.propTypes = {
  isSixteenToSeventeen: PropTypes.bool,
  registrationType: PropTypes.oneOf([MemberTypeStrings.GROUP, MemberTypeStrings.ONLINE]),
  publicHost: PropTypes.string.isRequired,
};

export default MedicalCheckAgeError;
